import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { ControleAdministracaoRow } from 'src/modules/serasa/serasa.pj.types'

export type ControleAdministracaoProps = {
    controleAdministracao: ControleAdministracaoRow
}

export default function ControleAdministracao({ controleAdministracao }: ControleAdministracaoProps) {
    return (
        <>
            <Divider textAlign="center">Controle de Administração</Divider>
            {controleAdministracao && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    {controleAdministracao.administradores.map((admin, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label="Administrador" value={admin.administracao} xs={6} />
                            <GridItem label="Cargo" value={admin.cargo} xs={6} />
                            <GridItem label="Nacionalidade" value={admin.nacionalidade} xs={6} />
                            <GridItem label="Data de Entrada" value={admin.entrada} xs={6} />
                            <GridItem label="Mandato" value={admin.mandato} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
